import { Injectable } from "@angular/core";
import { getAuth, verifyPasswordResetCode,confirmPasswordReset,sendPasswordResetEmail, signInWithEmailAndPassword } from '@angular/fire/auth';
import { FirebaseApp } from "firebase/app";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
   

    constructor() { }


    /**
     * 
     * @param auth 
     * @param email 
     * @returns 
     */
    public resetPasswordInit(auth, email: string) {
        return sendPasswordResetEmail(auth, email, { url: 'http://localhost:4200/auth' });
    }

    /**
     * 
     * @param auth 
     * @param actionCode 
     * @returns 
     */
    public verifyPasswordResetCode(auth, actionCode: any) {

        return verifyPasswordResetCode(auth, actionCode);
    }

    public confirmPassword(auth, actionCode: any, password: any) {
        // Save the new password.   
      return confirmPasswordReset(auth,actionCode,password);
      }

}